import axios from "axios";
import { toast } from "react-toastify";
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const submitBid = async(bidAmount,vehicleId) => {
  const user_id = localStorage.getItem('userId'); 
   if(bidAmount != null && bidAmount > 0 && vehicleId != null && vehicleId >0) {
    var da= {bid_amount:bidAmount,userId:user_id,vehicle_id:vehicleId}

    if (bidAmount % 1000 !== 0) {
      //toast.warning('Bid amount must be a multiple of 1000');
      var low = "Bid amount must be a multiple of 1000";
      return low;
    }
    
    await axios.post(global.apiUrl+'/submitBidding',JSON.stringify(da)
  ).then(function(response)
        {
          
            let status= response.data['status'];
            
            if(status == 400)
            {

                toast.error('Cant Place Lesser Bid/Not Allowed');
                
            }
            
            else
            {
              toast.success('Bidding Placed Successfully!',);
                window.location.reload();
                //document.getElementByID("#exampleModal"+vehicleId).modal('hide');
            }
  
        }
  
        )
    }
    else
    {
        toast.warning('Please Enter Correct Bid Amount');
    }
  }
  export default submitBid;